import { jsx as r, jsxs as m } from "react/jsx-runtime";
import { N as a } from "../../vendor-Dd6qj6gJ.js";
import { CalloutIcon as n } from "../CalloutIcon/index.js";
import { c as e } from "../../styles.module-BF2N4g8-.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as l } from "../../utils/omitStyleRenderProps/index.js";
import { useTableContext as c } from "./tableContext.js";
import { DotProgress as p } from "../DotProgress/index.js";
function d({ renderEmptyState: o, ...t }) {
  const { isLoading: s } = c();
  return /* @__PURE__ */ r(
    a,
    {
      ...l(t),
      renderEmptyState: (i) => o ? o(i) : s ? (
        // TODO: SkeletonLoader
        // - if empty, use default # of skeleton rows
        // - if items, use # of items for # of skeleton rows
        /* @__PURE__ */ r("div", { className: e.emptyState, children: /* @__PURE__ */ r(p, { "aria-label": "Loading..." }) })
      ) : /* @__PURE__ */ m("div", { className: e.emptyState, children: [
        /* @__PURE__ */ r(n, { icon: "search-results", color: "blue", size: "sm" }),
        /* @__PURE__ */ r("span", { children: "No results found." })
      ] })
    }
  );
}
d.displayName = "Table.Body";
export {
  d as Body
};
